import ClosedJobs from "./closedJobs";
export default ClosedJobs;